import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import styles from './OtherImageryVendor.css';
import OtherImageryEvent from './OtherImageryEvent';

export const toCamelCase = (str) => {
  if (!str) {
    return '';
  }
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => index === 0 ? word.toLowerCase() : word.toUpperCase())
    .replace(/\s+/g, '');
};

function OtherImageryVendor({
  activeSubLayerId,
  handleSelectEvent,
  layers,
  locale,
  vendor,
}) {
  const layerKeys = Object.keys(layers);
  const camelCaseVendor = toCamelCase(activeSubLayerId.vendor);
  const isActive = (currentVendor, key, index) => {
    const {
      vendor: activeVendor,
      layer: activeKey,
      index: activeIndex,
    } = activeSubLayerId;

    return (
      currentVendor === activeVendor &&
      key === activeKey &&
      index === activeIndex
    );
  };

  return (
    <div>
      <div
        className={styles.vendor}
        data-test-id="dmb-other-imagery-vendor-name"
      >
        {getMessage(`layer.${camelCaseVendor}`)}
      </div>
      <div>
        {layerKeys.map((key) => {
          const finalLayers = layers[key];
          return finalLayers.map(({ date, name }, index) => (
            <OtherImageryEvent
              active={isActive(vendor, key, index)}
              date={date}
              handleSelectEvent={handleSelectEvent(vendor, key, index)}
              key={`${key} ${date}`}
              locale={locale}
              name={name}
            />
          ));
        })}
      </div>
    </div>
  );
}

OtherImageryVendor.propTypes = {
  activeSubLayerId: PropTypes.object.isRequired,
  handleSelectEvent: PropTypes.func.isRequired,
  layers: PropTypes.object.isRequired,
  locale: PropTypes.string,
  vendor: PropTypes.string.isRequired,
};

export default OtherImageryVendor;
